export function roundDown(number, decimals) {
  if (!number) {
    return;
  }
  decimals = decimals || 0;
  return Math.floor(number * Math.pow(10, decimals)) / Math.pow(10, decimals);
}
